import { locale } from '../locale';

const LANGUAGES = {
  de: 'Deutsch',
  en: 'English',
};

class LocationService {
  localStorage = window.localStorage;

  locale = locale;

  getLanguage() {
    const code = this.localStorage.getItem('languageCode');
    if (!code || !LANGUAGES[code]) {
      return { code: locale, caption: LANGUAGES[locale] };
    }
    return {
      code,
      caption: LANGUAGES[code],
    };
  }

  setLanguage(languageCode) {
    if (!LANGUAGES[languageCode]) throw Error('Language not supported');
    this.language = { code: languageCode, caption: LANGUAGES[languageCode] };
    this.localStorage.setItem('languageCode', languageCode);
    return {
      code: languageCode,
      caption: LANGUAGES[languageCode],
    };
  }

  getSupportedLanguages() {
    return Object.entries(LANGUAGES).map(language => ({ code: language[0], caption: language[1] }));
  }
}

export default new LocationService();
